import _ from 'lodash';

import {
    OBSERVACIO_OBTENIR_VARIABLES_FORMULARI,
    OBSERVACIO_FORMULARI_MODIFICAR_VALOR,
    OBSERVACIO_INICIALITZAR,
    OBSERVACIO_FORMULARI_INICIALITZAR,
    OBSERVACIO_FORMULARI_COMPROVAR,
    OBSERVACIO_FORMULARI_IGNORAR_FILTRES_COHERENCIA_PER_VARIABLE,
    OBSERVACIO_FORMULARI_SELECCIONAR_VALOR_INAPRECIABLE
} from '../../../actions/actionTypes';

import { calculaErrorsCoherencia } from './filtresCoherencia';
import obtenirValorsVariablesAutomatiques from './calculsAutomatics';

const ESTAT_INICIAL_VARIABLES_FORMULARI = null;

function afegeixCampValorNou(estatAnterior, accio) {
    let estatNou = _.cloneDeep(estatAnterior);
    const { idVariable, valor, estacio } = accio;
    modificarValorVariable(estatNou, idVariable, valor);
    obtenirValorsVariablesAutomatiques(estatNou, estacio).forEach(valorVariablesAutomatiques => {
        if (idVariable !== valorVariablesAutomatiques.idVariable)
            modificarValorVariable(estatNou, valorVariablesAutomatiques.idVariable, valorVariablesAutomatiques.valor, valorVariablesAutomatiques.esValorCalculAutomatic);

    });
    return estatNou;
}

const obtenirVariables = accio => {
    const { variables, estacio } = accio;
    obtenirValorsVariablesAutomatiques(variables, estacio).forEach(valorVariablesAutomatiques => {
        modificarValorVariable(variables, valorVariablesAutomatiques.idVariable, valorVariablesAutomatiques.valor, valorVariablesAutomatiques.esValorCalculAutomatic);
    });

    return variables;
};

const modificarValorVariable = (variables, idVariable, valor, esValorCalculAutomatic) => {

    Object.keys(variables).forEach(indexGrup => {
        variables[indexGrup] = variables[indexGrup].map(variable => {
            if (variable.idVariable === idVariable) {
                if (esValorCalculAutomatic !== undefined)
                    return {...variable, valorNou: valor, esValorCalculAutomatic };
                else 
                    return {...variable, valorNou: valor };
            } else {
                return variable;
            }
        });
    });

};

function ignorarFiltresDeCoherenciaPerVariable(estatAnterior, accio) {
    let estatNou = _.cloneDeep(estatAnterior);
    const idVariableAModificar = accio.idVariable;
    const ignorarFiltresDeCoherencia = accio.valorCheckbox;
    let variableAModificar;

    Object.keys(estatNou).forEach(indexGrup => {
        if (!variableAModificar) {
            variableAModificar = estatNou[indexGrup].find(variable => variable.idVariable === idVariableAModificar);
        }
    });

    if (variableAModificar) {
        variableAModificar.ignorarFiltresCoherencia = ignorarFiltresDeCoherencia;
    }

    return estatNou;
}

const seleccionarValorInapreciable = (estatAnterior, accio) => {
    let estatNou = _.cloneDeep(estatAnterior);
    const idVariableAModificar = accio.idVariable;
    const seleccionarValorInapreciable = accio.valorCheckbox;
    let variableAModificar;

    Object.keys(estatNou).forEach(indexGrup => {
        if (!variableAModificar) {
            variableAModificar = estatNou[indexGrup].find(variable => variable.idVariable === idVariableAModificar);
        }
    });

    if (variableAModificar) {
        variableAModificar.esValorInapreciable = seleccionarValorInapreciable;
    }

    return estatNou;
};

const variablesFormulari = (state = ESTAT_INICIAL_VARIABLES_FORMULARI, action) => {

    switch (action.type) {
        case OBSERVACIO_OBTENIR_VARIABLES_FORMULARI:
            return obtenirVariables(action);
        case OBSERVACIO_FORMULARI_MODIFICAR_VALOR:
            return afegeixCampValorNou(state, action);
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_VARIABLES_FORMULARI;
        case OBSERVACIO_FORMULARI_INICIALITZAR:
            return ESTAT_INICIAL_VARIABLES_FORMULARI;
        case OBSERVACIO_FORMULARI_COMPROVAR:
            return calculaErrorsCoherencia(state);
        case OBSERVACIO_FORMULARI_IGNORAR_FILTRES_COHERENCIA_PER_VARIABLE:
            return ignorarFiltresDeCoherenciaPerVariable(state, action);
        case OBSERVACIO_FORMULARI_SELECCIONAR_VALOR_INAPRECIABLE:
            return seleccionarValorInapreciable(state, action);
        default:
            return state;
    }
};

export default variablesFormulari;



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/variables.js